import { defineComponent, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import validator from 'validator';
import { Button, Input } from '@yellowcard/components-library-vue3';
import CurrencyBadge from '@/components/currency/CurrencyBadge.vue';
import CurrencyRate from '@/components/currency/CurrencyRate.vue';
import { numberFormat } from '@/utils/helpers';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import useTransactionsStore from '@/store/modules/transactions';
import { useGeneralStore } from '@/store/modules/general';
import { useAuthStore } from '@/store/modules/auth';
import { TransactTypes } from '@/types/transact';
var BuySteps = TransactTypes.TransactSteps;
export default defineComponent({
    name: 'BuyCryptoComponent',
    components: {
        Button,
        CurrencyBadge,
        CurrencyRate,
        Input,
    },
    emits: ['refresh'],
    setup() {
        const transactionsStore = useTransactionsStore();
        const generalStore = useGeneralStore();
        const { coinCurrencySelect } = storeToRefs(generalStore);
        const { selectedCrypto, selectedCurrency, selectedCryptoAmount, selectedCurrencyAmount, maxTransactionAmount, minTransactionAmount, rates, currentStep, } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { isLoggedIn, partnerId } = storeToRefs(authStore);
        const showCryptoInput = ref(false);
        const showCurrencyInput = ref(false);
        const currencyAmountValid = ref(false);
        const cryptoAmountValid = ref(false);
        const errorMessage = ref('');
        const removeCharsFromNumber = (number) => number.replace(/,/g, '');
        const onAmountEntered = (value) => {
            const formattedValue = removeCharsFromNumber(value);
            errorMessage.value = '';
            if (!validator.isNumeric(formattedValue)) {
                errorMessage.value = 'Enter a valid amount';
            }
            else if (Number(formattedValue) < minTransactionAmount.value) {
                errorMessage.value = `Please enter an amount greater than ${selectedCurrency.value.currency} ${numberFormat(minTransactionAmount.value)}`;
            }
            else if (Number(formattedValue) > maxTransactionAmount.value) {
                errorMessage.value = `Please enter an amount lower than ${selectedCurrency.value.currency} ${numberFormat(maxTransactionAmount.value)}`;
            }
            selectedCurrencyAmount.value.amount = Number(formattedValue);
            selectedCryptoAmount.value.amount =
                transactionsStore.calculateCryptoAmount(selectedCurrencyAmount.value.amount);
        };
        onMounted(async () => {
            if (!rates.value.length) {
                rates.value = await transactionsStore.getRates();
                if (selectedCurrencyAmount.value.amount) {
                    selectedCryptoAmount.value.amount =
                        transactionsStore.calculateCryptoAmount(selectedCurrencyAmount.value.amount);
                }
            }
            if (selectedCurrencyAmount.value.amount) {
                onAmountEntered(`${selectedCurrencyAmount.value.amount}`);
            }
        });
        const onBadgeSelected = async (event) => {
            if (event.type === 'Currency') {
                coinCurrencySelect.value = 'Currency';
            }
            else {
                coinCurrencySelect.value = 'Coin';
            }
            currentStep.value = BuySteps.CURRENCY_COIN_SELECT;
        };
        const focusInput = () => {
            const inputElement = document.getElementById('buy-crypto-currency-input');
            if (inputElement) {
                if (selectedCurrencyAmount.value.amount) {
                    inputElement.value = numberFormat(selectedCurrencyAmount.value.amount, 2);
                }
                const eventType = 'onfocusin' in inputElement ? 'focusin' : 'focus';
                const event = new Event(eventType);
                inputElement?.focus();
                inputElement?.dispatchEvent(event);
            }
            else {
                console.log('Element not found');
            }
        };
        const toggleCurrencyInput = () => {
            if (!showCurrencyInput.value) {
                showCurrencyInput.value = !showCurrencyInput.value;
            }
        };
        const toggleCryptoInput = () => {
            showCryptoInput.value = !showCryptoInput.value;
        };
        const onKeyPress = (event) => {
            event.preventDefault();
        };
        const onBuyButtonClicked = () => {
            trackEvent(MIXPANEL_EVENTS.BUY.BUY, {
                logged_in: isLoggedIn.value,
                partner: partnerId.value,
            });
            currentStep.value = TransactTypes.TransactSteps.BUY_2;
        };
        watch(selectedCurrencyAmount.value, value => {
            onAmountEntered(`${value.amount}`);
        });
        return {
            showCryptoInput,
            onBadgeSelected,
            currencyAmountValid,
            cryptoAmountValid,
            toggleCurrencyInput,
            toggleCryptoInput,
            showCurrencyInput,
            onKeyPress,
            selectedCrypto,
            selectedCurrency,
            selectedCryptoAmount,
            selectedCurrencyAmount,
            numberFormat,
            onAmountEntered,
            errorMessage,
            maxTransactionAmount,
            minTransactionAmount,
            onBuyButtonClicked,
            focusInput,
        };
    },
});
